import React from "react";
import { intl } from "LocaleWrapper";
import { Table } from "@cofano/cck";
import DataFormat from "../utils/DataFormat";
import { localeAsLanguageKey } from "../../utils/locales";
import { UserLink } from "utils/LinkUtils";
import { FormattedDate } from "utils/DateUtils";
import ContractRecipient from "./ContractRecipient";

const ContractSendHistory = ({ history }) => (
	<Table
		id="cckTableContractSendHistory"
		disableFooter={true}
		content={history}
		columns={[ {
			id: "timestamp",
			title: intl.formatMessage({ id: "TIMESTAMP" }),
			render: (row) => <FormattedDate date={row.timestamp} />,
		}, {
			id: "status",
			title: intl.formatMessage({ id: "STATUS" }),
			render: (row) => DataFormat.contractStatus(row.status),
		}, {
			id: "versionNumber",
			title: intl.formatMessage({ id: "TEMPLATES_VERSION" }),
		}, {
			id: "sendBy",
			title: intl.formatMessage({ id: "SENDER" }),
			render: (row) => <UserLink user={row.sendBy} />,
		}, {
			id: "language",
			title: intl.formatMessage({ id: "USER_LANGUAGE" }),
			render: (row) => row.language?.code && localeAsLanguageKey(row.language.code),
		}, {
			id: "receiver",
			title: intl.formatMessage({ id: "RECEIVER" }),
			width: 150,
			render: (row) => <ContractRecipient contractHistoryItem={row} />,
		} ]} />
);

export default ContractSendHistory;
